var render = function render(){var _vm=this,_c=_vm._self._c;return _c('validation-field',{attrs:{"name":_vm.name,"label":_vm.label},scopedSlots:_vm._u([{key:"default",fn:function({ id, modelValue, onChange, name, invalid }){return [_c('base-select',{attrs:{"id":id,"name":name,"value":modelValue,"invalid":invalid},on:{"changeValue":function($event){onChange($event);
        _vm.$emit('change', $event);}}},[_vm._t("default")],2)]}}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }